import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhyItWorksSection } from '../components/WhyItWorksSection';
import { ContentsSection } from '../components/ContentsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full overflow-x-hidden" data-id="element-465">
      <HeroSection data-id="element-466" />
      <PainSection data-id="element-467" />
      <SolutionSection data-id="element-468" />
      <WhyItWorksSection data-id="element-469" />
      <ContentsSection data-id="element-470" />
      <TestimonialsSection data-id="element-471" />
      <FAQSection data-id="element-472" />
      <PricingSection data-id="element-473" />
      <Footer data-id="element-474" />
    </main>;
}